import { render, staticRenderFns } from "./HomeAdmin.vue?vue&type=template&id=650e0fcc"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"
import style0 from "./HomeAdmin.vue?vue&type=style&index=0&id=650e0fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports